import "./App.css";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import CloudClinicPartner from "./cloudclinicpartner";
import Home from "./home";
import CampaignePage from "./campaigne";
import ReferralPage from "./referralPage";
import CircleInvitePage from "./circleInvitePage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/referral/:code" element={<ReferralPage />} />
      <Route path="/circle/:code" element={<CircleInvitePage />} />
      {/* <Route path='/cloudclinicpartner' element={<CloudClinicPartner />} /> */}
      {/* <Route path='/mycloudclinic' element={<CampaignePage />} /> */}
      {/* <Route path='/cloudclinicpartner' element={<CloudClinicPartner />} />  */}
    </Routes>
  );
}

export default App;
